import { Container, Row, Col } from "react-bootstrap";
import IconCard from "../../Components/IconCard";
import cardData from "../../modules/applicationLinks";

export default function Home({ leftBannerLogo, isLoading, thumbnail, headerColor }) {
  const thumbnailData = thumbnail.length > 0 ? thumbnail : cardData;
  return (
    <>
      <section className="">
        <Container>
          <Row className="row-gap-6 align-items-center">
            <Col xs={12} lg={6}>
              <div className="position-relative mx-auto mx-lg-0">
                {!isLoading ? (
                  <img
                    src={
                      leftBannerLogo
                        ? leftBannerLogo
                        : `${process.env.PUBLIC_URL}/assets/images/about_image.png`
                    }
                    alt="About"
                    className="img-fluid"
                  />
                ) : null}
                {/* <img src="https://storage.googleapis.com/ampersad-static-files/test/final_SSO_left_img.png" alt="About" className='img-fluid' /> */}
              </div>
            </Col>
            <Col xs={12} lg={6}>
              {!isLoading && (
                <>
                  <Row className="justify-content-center row-gap-3 row-gap-md-4 row-gap-lg-5">
                    {thumbnailData?.map((item, index) => (
                      <Col xs={12} md={6} key={index}>
                        <IconCard cardData={item} headerColor={headerColor} />
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
